import { useSelector } from 'react-redux'
import { formatDate } from 'Utils/Dates'

const useDates = () => {
  const { isCountryUs } = useSelector(state => state.campground)
  const calendarFormat = isCountryUs ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
  const calendarFormatDash = isCountryUs ? 'YYYY-MM-DD' : 'DD-MM-YYYY'
  const datePickerFormat = isCountryUs ? 'ddd, MMM. Do' : 'ddd DD MMM'
  const lllFormat = isCountryUs ? 'lll' : 'DD MMMM YYYY h:mm A'
  const longFormat = isCountryUs ? 'MMMM DD, YYYY h:mm A zz' : 'DD MMMM YYYY h:mm A zz'
  const urlFormat = 'YYYY-MM-DD'

  const parseDate = date => formatDate(date, { format: calendarFormat })

  return { calendarFormat, calendarFormatDash, datePickerFormat, lllFormat, longFormat, parseDate, urlFormat }
}

export default useDates
